<template>
  <div>
    <Breadcrumb msg1="收费管理" msg2="交班记录" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6">
          <el-date-picker v-model="query.shift_date" type="date" value-format="yyyy-MM-dd" placeholder="交班日期"></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新建交班</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="交班日期" prop="shiftDate" width="120"></el-table-column>
        <el-table-column label="收银员ID" prop="cashierId" width="100"></el-table-column>
        <el-table-column label="系统应收" prop="expectAmount" width="110"></el-table-column>
        <el-table-column label="实际金额" prop="actualAmount" width="110"></el-table-column>
        <el-table-column label="差异" prop="diffAmount" width="100">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.diffAmount !== 0 ? '#F56C6C' : '' }">{{ scope.row.diffAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog title="新建交班" :visible.sync="show" width="450px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="交班日期"><el-date-picker v-model="form.shift_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-form-item>
        <el-form-item label="实际金额" required><el-input v-model.number="form.actual_amount" type="number" placeholder="清点现金+各类支付总额"></el-input></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea"></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, shift_date: '' },
      list: [],
      total: 0,
      show: false,
      form: { shift_date: '', actual_amount: 0, remark: '' }
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      this.$axios.get('/shifts', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    add () {
      this.form = { shift_date: '', actual_amount: 0, remark: '' }
      this.show = true
    },
    save () {
      this.form.cashier_id = window.sessionStorage.getItem('id')
      this.$axios.post('/shifts', () => { this.show = false; this.getData() }, this.form)
    }
  }
}
</script>
